import React, { useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
    Checkbox,
    FormControlLabel,
    FormControl,
    FormGroup,
    Table,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField, makeStyles
} from "@material-ui/core";
import {Tab, Tabs} from "react-bootstrap";
import "date-fns";

const fakeData = [
    {
        type: 0,
        text: "Reports",
    },
    {
        type: 1,
        text: "AirPlus Requirements",
        description: "by Grog John",
        iconImage: toAbsoluteUrl("/media/files/doc.svg"),
    },
    {
        type: 1,
        text: "TechNav Documentation",
        description: "by Mary Brown",
        iconImage: toAbsoluteUrl("/media/files/pdf.svg"),
    },
    {
        type: 1,
        text: "All Framework Docs",
        description: "by Grog John",
        iconImage: toAbsoluteUrl("/media/files/zip.svg"),
    },
    {
        type: 1,
        text: "AirPlus Requirements",
        description: "by Tim Hardy",
        iconImage: toAbsoluteUrl("/media/files/xml.svg"),
    },
    {
        text: "Customers",
        type: 0,
    },
    {
        type: 1,
        text: "Jimmy Curry",
        description: "Software Developer",
        iconImage: toAbsoluteUrl("/media/users/300_11.jpg"),
    },
    {
        type: 1,
        text: "Milena Gibson",
        description: "UI Designer",
        iconImage: toAbsoluteUrl("/media/users/300_16.jpg"),
    },
    {
        type: 1,
        text: "Stefan JohnStefan",
        description: "Marketing Manager",
        iconImage: toAbsoluteUrl("/media/users/300_22.jpg"),
    },
    {
        type: 1,
        text: "Anna Strong",
        description: "Software Developer",
        iconImage: toAbsoluteUrl("/media/users/300_5.jpg"),
    },
    {
        type: 0,
        text: "Files",
    },
    {
        type: 1,
        text: "2 New items submitted",
        description: "Marketing Manager",
        iconClassName: "flaticon2-box font-danger",
    },
    {
        type: 1,
        text: "79 PSD files generated",
        description: "by Grog John",
        iconClassName: "flaticon-psd font-brand",
    },
    {
        type: 1,
        text: "$2900 worth products sold",
        description: "Total 234 items",
        iconClassName: "flaticon2-supermarket font-warning",
    },
    {
        type: 1,
        text: "4 New items submitted",
        description: "Marketing Manager",
        iconClassName: "flaticon-safe-shield-protection font-info",
    },
];

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200
    }
}));


export default function MyPage() {
    const [setLoading] = useState(false);
    const [age, setAge] = useState('');
    const [setData] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const classes = useStyles();

    let timeoutId;

    const clearTimeout = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = undefined;
        }
    };

    const handleSearchChange = (event) => {
        setData(null);
        setSearchValue(event.target.value);

        if (event.target.value.length > 2) {
            clearTimeout();

            setLoading(true);

            // simulate getting search result
            timeoutId = setTimeout(() => {
                setData(fakeData);
                setLoading(false);
            }, 500);
        }
    };

    const handleChange = (event) => {
        setAge(event.target.value);
    };


    useEffect(() => {
        return () => {
            clearTimeout();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    return (
        <>
         <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
        <Tab eventKey="home" title="Home">
          How can I then return in happy plight, That am debarre'd the
          benefit of rest? When day's oppression is not eas'd by night,
          But day by night and night by day oppress'd, And each, though
          enemies to either's reign, Do in consent shake hands to
          torture me, The one by toil, the other to complain How far I
          toil, still farther off from thee. I tell the day, to please
          him thou art bright, And dost him grace when clouds do blot
          the heaven:
                </Tab>
        <Tab eventKey="profile" title="Profile">
          How sweet and lovely dost thou make the shame Which, like a
          canker in the fragrant rose, Doth spot the beauty of thy
          budding name! O! in what sweets dost thou thy sins enclose.
          That tongue that tells the story of thy days, Making
          lascivious comments on thy sport, Cannot dispraise, but in a
          kind of praise; Naming thy name, blesses an ill report. O!
          what a mansion have those vices got Which for their habitation
          chose out thee,
                </Tab>
      </Tabs>
            <div className="OrderManagement">
                {/*篩選格*/}
                <div className="d-flex form-group">
                    <h3 className="menu-text">待處理</h3>
                    <i className="fas fa-filter"></i>
                    <span className="mx-5"></span>
                    <h3 className="menu-text ">異常</h3>
                    <i className="fas fa-filter"></i>
                </div>

                {/*輸入搜尋格*/}
                <form className="form-group quick-search-form mx-2">
                    <div className="d-flex input-group">
                        <input
                            type="text"
                            autoFocus={true}
                            placeholder="搜尋 訂單編號/收件人手機"
                            value={searchValue}
                            onChange={handleSearchChange}
                            className="text"
                        />
                        <div className={`input-group-prepend`}>
                            <span className="input-group-text">
                                <span className="svg-icon svg-icon-lg">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/General/Search.svg"
                                        )}
                                    />
                                </span>
                            </span>
                        </div>
                    </div>
                </form>

                {/*日期格*/}
                <div className="form-group d-flex my-5">
                    <h3 className="menu-text d-flex align-items-flex-end">訂單日期 : </h3>
                    <form className={classes.container} noValidate>
                        <TextField
                            id="startDay"
                            /*label="startDay"*/
                            type="date"
                            defaultValue="2017-05-24"
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                        <h3 className="menu-text"> ~ </h3>
                        <form className={classes.container} noValidate>
                            <TextField
                                id="dueDay"
                                /*label="dueDay"*/
                                type="date"
                                defaultValue="2017-05-24"
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </form>
                    </form>
                </div>

                {/* input*/}
                <div className="form-group d-flex my-5">
                    <h3>貨運公司 : </h3>
                    <input
                        type="text"
                        autoFocus={true}
                        className="mx-2"
                    />
                </div>

                {/* checkbox Group 只有兩個*/}
                <div className="checkBox form-group d-flex">

                    <h3>處理狀態 : </h3>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="待處理"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="已結案"
                        />
                    </FormGroup>
                </div>

                {/* checkbox Group有兩列 */}
                <div className="checkBox form-group d-flex">
                    <h3>訂單物流狀態 : </h3>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="收到訂單"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="配送中"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="已送達"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="異常"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="拒收"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="訂單取消"
                        />
                    </FormGroup>
                </div>
                <div className="form-group d-flex">
                    <span className="mx-24"></span>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨申請"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨收貨"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨收貨完成"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨收貨失敗"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="取消退訂"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨完成"
                        />
                    </FormGroup>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox />
                            }
                            label="退貨不核可"
                        />
                    </FormGroup>
                </div>
                <div className="button form-group d-flex">
                    <Button variant="contained" color="secondary" className={classes.button}>
                        查詢
                    </Button>
                </div>
                <div className="button form-group d-flex">
                    <Button variant="contained" className={classes.button}>
                        導出客戶清單
                    </Button>
                </div>


                {/* 下拉式select */}
                <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">Age</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={age}
                        onChange={handleChange}
                    >
                        <MenuItem value={10}>Ten</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                </FormControl>

                {/* Table表格 */}
                <Table responsive>
                    <thead>
                        <tr>
                            <th>訂單日期</th>
                            <th>訂單編號</th>
                            <th>收件人姓名</th>
                            <th>訂單編號</th>
                            <th>收件人姓名</th>
                            <th>收件人手機</th>
                            <th>處理狀態</th>
                            <th>備註</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2020/08/29</td>
                            <td>20090100000101</td>
                            <td>李奧納多皮卡丘</td>
                            <td>0910-123-123</td>
                            <td>待處理</td>
                            <td>已訂貨</td>
                            <td></td>
                        </tr>
                    </tbody>
                </Table>




            </div>
        </>
    )
}  